import { ImagePlus } from "lucide-react";

// Elegant placeholder for the client to swap in their own installation photos.
export const UploadPlaceholder = ({ label = "Installation photo", note = "Your photo here", className = "" }) => (
  <div
    className={`relative flex h-full w-full flex-col items-center justify-center gap-3 bg-sand border border-dashed border-navy/25 ${className}`}
    data-testid="upload-placeholder"
  >
    <div className="grid place-items-center h-14 w-14 rounded-full bg-navy/5 text-navy">
      <ImagePlus className="h-6 w-6" />
    </div>
    <div className="text-center px-4">
      <p className="font-serif text-lg text-navy leading-tight">{label}</p>
      <p className="mt-1 text-[10px] uppercase tracking-[0.18em] text-muted-foreground">{note}</p>
    </div>
  </div>
);
